export function formatPhoneNumber(phoneNumber) {
	const digits = ("" + phoneNumber).replace(/\D/g, "");
	const m = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
	return !m ? null : m[1] + "-" + m[2] + "-" + m[3];
}

export function maskPhoneNumber(pattern, input) {
	if (typeof input === "undefined" || input === null) {
		return "";
	}

	let result = input;
	for (let i = 0; i < pattern.length && i < result.length; i++) {
		if (isNaN(parseInt(pattern[i], 10))) {
			if (result[i] !== pattern[i]) {
				result = result.slice(0, i).concat(pattern[i], result.slice(i));
			}
		} else {
			while (result.length > i && isNaN(parseInt(result[i], 10))) {
				result = result.slice(0, i).concat(result.slice(i + 1));
			}
		}
	}
	result = result.slice(0, pattern.length);

	return result;
}

function lowerCase(str){
	return str.toLowerCase();
}

function upperCase(str){
	return str.toUpperCase();
}

export function unCamelCase(str){
	str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, "$1 $2");
  	str = str.toLowerCase(); //add space between camelCase text
  	return str;
}

export function properCase(str){
	return lowerCase(str).replace(/^\w|\s\w/g, upperCase);
}